import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import FiltroPedidosFacturados from "./FiltroPedidosFacturados";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { useHistory, useLocation } from "react-router-dom";
import { useBox } from "../ReporteCobranza/Helper/useBox";
import { GetKey } from "../ReporteCobranza/Actions/GetContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Modal, Button, Grid, TextField, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { SolicitudesCreditoFacturadasHeader } from "../../Ventas/SolicitudesCreditoFacturadas/SolicitudesCreditoFacturadasHeader";

import Swal from "sweetalert2";
import { GetMonthName } from "../../helpers/GetMonthName";
// import { SolicitudesCreditoFacturadasHeader } from "./SolicitudesCreditoFacturadasHeader";

export const PedidosFacturadosScreen = () => {
  const history = useHistory();
  const location = useLocation();
  const permisos = location.state.permisos;
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [boxstate, setBoxState] = useBox();
  const [showModal, setShowModal] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [cardSelected, setCardSelected] = useState(1);
  const storedState = JSON.parse(localStorage.getItem('state')) || {};

  const [state, setState] = useState({
    ejercicio: storedState.ejercicio || boxstate.ejercicio,
    periodo: storedState.periodo || boxstate.periodo,
    adr: storedState.adr || [],
    sucursal: storedState.sucursal || [],
    departamento: storedState.departamento || [],
    linea: storedState.linea || "C"
  });

  const [stateFiltro, setStateFiltro] = useState({
    ejercicio: storedState.ejercicio || boxstate.ejercicio,
    adr: (storedState.adr ? storedState.adr.filter(item => item.checked).map(({ idadr, adr }) => ({ idadr, adr })) : boxstate.pv.adr),
    sucursal: (storedState.sucursal ? storedState.sucursal.filter(item => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal })) : boxstate.pv.sucursal)
  });

  useEffect(() => {
    setStateFiltro({
      ejercicio: storedState.ejercicio || boxstate.ejercicio,
      adr: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal
    });
  }, [boxstate]);

  const handleShowModal = (item) => {
    setSelectedCliente(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCliente(null);
  };
  const [titulo, setTitulo] = useState("PEDIDOS FACTURADOS");

  const onHome = () => {
    history.push("/Creditoycobranza/Main");
  };
  const onExecute = (ejercicio, periodo, linea) => {
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);

      }
      else {
        sucursales = "0"
      }
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `PedidosFacturados/CargaPedidosFacturados?ejercicio=${Number(
            ejercicio
          )}&periodo=${periodo}&sucursales=${sucursales}&adr=${adr}&operacion=${linea}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setTitulo(
            `PEDIDOS FACTURADOS ${GetMonthName(
              periodo
            ).toLocaleUpperCase()} - ${ejercicio}`
          );
          setData(result);
          setDataTable(result);
          resolve({ mensaje: "Consulta realizada" });
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  //pagare = 10,22,27
  //pedido = 25,55
  //factura = 28,71

  useEffect(() => {
    const añoActual = new Date().getFullYear();
    onExecute(state.ejercicio, state.periodo, state.linea);
  }, []);

  const onExecuteCards = (ejercicio, periodo, linea) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = GetKey(permisos, ["idsucursal"]);
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    // console.log(adr, sucursales)
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `PedidosFacturados/CargaPedidosFacturados?ejercicio=${Number(
            ejercicio
          )}&periodo=${periodo}&sucursales=${sucursales}&adr=${adr}&operacion=${linea}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setDataTable(result);
          resolve({ mensaje: "Consulta realizada" });
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const totalPedidosEncontrados = data.length;
  const prestamosnumero = data.filter(
    (pedido) => pedido.operacion === "Prestamos"
  );
  const totalPrestamos = prestamosnumero.length;
  const mhusanumero = data.filter((pedido) => pedido.operacion === "Mhusa");
  const totalmhusa = mhusanumero.length;

  const capitalizeWords = (str) => {
    return str
      ? str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
      : "";
  };

  const onImprimirPedido = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerPedidoFacturado?folio=${selectedCliente.folio
        }&iddocumento=${Number(iddocumento)}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (
          result.length !== undefined &&
          result.length !== null &&
          result.length > 0
        ) {
          result.forEach((element) => {
            const linkSource =
              "data:application/pdf;base64," + element.documento;
            const downloadLink = document.createElement("a");
            const fileName = `${element.nombredocumento}.${element.extension}`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
          return;
        }

        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDOS FACTURADOS", error.mensaje, "error");
      });
  };

  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"pedidos-facturados"}
    >
      <div className="pedidos-facturados-actions">
        <div
          className="pedidos-facturados-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="resumen-saldos-cartera-objetivo-header-mensual">
          <FiltroPedidosFacturados
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            sucursales={permisos}
          />
        </div>
      </div>
      <div className="pedidos-facturados-container">
        <LoaderScreen loader={loader} />
        {/* <div className="pedidos-facturados-numero-pedidos">
          {`Se encontraron ${totalPedidosEncontrados} cliente(s)`}
        </div> */}
        {data === undefined || data === null || data.length === 0 ? (
          <div></div>
        ) : (
          <div>
            <div className="solicitud-credito-facturada-container-resumen-pedidos-facturados">
              <SolicitudesCreditoFacturadasHeader
                titulo={"TOTAL"}
                cantidad={totalPedidosEncontrados}
                className={
                  "solicitud-credito-facturada-container-resumen-item-click-pedidos-facturados"
                }
                onClick={() => {
                  onExecuteCards(boxstate.ejercicio, boxstate.periodo, "C");
                  setCardSelected(1);
                }}
                porcentaje={"100%"}
                activo={cardSelected === 1 ? true : false}
              />
              <SolicitudesCreditoFacturadasHeader
                titulo={"MHUSA"}
                cantidad={totalmhusa}
                className={
                  "solicitud-credito-facturada-container-resumen-item-click-pedidos-facturados"
                }
                onClick={() => {
                  onExecuteCards(boxstate.ejercicio, boxstate.periodo, "M");
                  setCardSelected(2);
                }}
                porcentaje={`${FormatMoney(
                  (totalmhusa / totalPedidosEncontrados) * 100,
                  0
                )}%`}
                activo={cardSelected === 2 ? true : false}
              />
              <SolicitudesCreditoFacturadasHeader
                titulo={"PC"}
                cantidad={totalPrestamos}
                className={
                  "solicitud-credito-facturada-container-resumen-item-click-pedidos-facturados"
                }
                onClick={() => {
                  onExecuteCards(boxstate.ejercicio, boxstate.periodo, "P");
                  setCardSelected(3);
                }}
                porcentaje={`${FormatMoney(
                  (totalPrestamos / totalPedidosEncontrados) * 100,
                  0
                )}%`}
                activo={cardSelected === 3 ? true : false}
              />
            </div>
            <div className="pedidos-facturados-table-container-2">
              <div className="pedidos-facturados-table-container-3 scroll-4">
                <table cellPadding={0} cellSpacing={0}>
                  <thead>
                    <tr>
                      <th>Línea</th>
                      <th>
                        <div>Sucursal</div>
                      </th>
                      <th>
                        <div>Razón Social</div>
                      </th>
                      <th>
                        <div>Folio Fiscal</div>
                      </th>
                      <th>
                        <div>Vencimiento</div>
                      </th>
                      <th>
                        <div>Tasa Normal</div>
                      </th>
                      <th>
                        <div>Moneda</div>
                      </th>
                      <th>
                        <div>Importe a Financiar</div>
                      </th>
                      <th>
                        <div>Interés Normal</div>
                      </th>
                      <th>
                        <div>Total a Pagar</div>
                      </th>
                      <th>
                        <div>Detalle</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataTable.map((item) => (
                      <tr
                        key={
                          item.idsucursal +
                          "-" +
                          item.operacion +
                          "-" +
                          item.folio +
                          "-" +
                          item.serie_fiscal +
                          "-" +
                          item.folio_fiscal +
                          "-" +
                          item.documento_pagare +
                          "-" +
                          item.vencimiento +
                          "-" +
                          item
                        }
                      >
                        <td>{item.operacion}</td>
                        <td>{capitalizeWords(item.sucursal)}</td>
                        <td>{capitalizeWords(item.razon_social)}</td>
                        <td className="ta-left">
                          {item.serie_fiscal + " - " + item.folio_fiscal}
                        </td>
                        <td>{item.vencimiento.split("T")[0]}</td>
                        <td>{`${item.tasa} %`}</td>
                        <td className="ta-center">{item.moneda}</td>
                        <td>{FormatMoney(item.importe_financiar, 0)}</td>
                        <td>{FormatMoney(item.interes_pactado, 0)}</td>
                        <td>{FormatMoney(item.total_pagar, 0)}</td>
                        <td>
                          <Button
                            variant="contained"
                            color="primary"
                            style={{
                              padding: "2px 6px",
                              fontSize: "12px",
                              minWidth: "auto",
                            }}
                            onClick={() => handleShowModal(item)}
                          >
                            <VisibilityIcon
                              style={{ margin: "0 2px 0 0", fontSize: "20px" }}
                            />{" "}
                            Mostrar
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <Modal open={showModal} onClose={handleCloseModal}>
              <div className="modal-content">
                {showModal && selectedCliente && (
                  <PlantillaScreen
                    titulo={selectedCliente.razon_social}
                    className={"asc-modal-pedidos-facturados"}
                  >
                    <div className="modal-content-wrapper">
                      <div className="form-container">
                        <Grid container spacing={1}>
                          <Grid container item spacing={1}>
                            <Grid item xs={12} sm={6} md={6}>
                              <TextField
                                label="Folio de la Solicitud"
                                value={selectedCliente.folio || "-"}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                              <TextField
                                label="Responsable de Cobranza"
                                value={capitalizeWords(
                                  selectedCliente.razon_social
                                )}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid container item spacing={1}>
                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  label="Asesor de Venta"
                                  value={selectedCliente.asesor_ventas || "-"}
                                  fullWidth
                                  margin="normal"
                                  InputProps={{ readOnly: true }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  label="Sucursal"
                                  value={
                                    capitalizeWords(selectedCliente.sucursal) ||
                                    "-"
                                  }
                                  fullWidth
                                  margin="normal"
                                  InputProps={{ readOnly: true }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                  label="Celular"
                                  value={
                                    capitalizeWords(selectedCliente.celular) ||
                                    "-"
                                  }
                                  fullWidth
                                  margin="normal"
                                  InputProps={{ readOnly: true }}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          {/* Segunda fila: ID EQUIP, Serie Fiscal, Folio Fiscal, Documento Factura, Documento Pagaré */}
                          <Grid container item spacing={1}>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="ID EQUIP"
                                value={selectedCliente.idequip || "-"}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Serie Fiscal"
                                value={selectedCliente.serie_fiscal || "-"}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Folio Fiscal"
                                value={selectedCliente.folio_fiscal || "-"}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Documento de la Factura"
                                value={selectedCliente.documento_factura || "-"}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Documento del Pagaré"
                                value={selectedCliente.documento_pagare || "-"}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                          </Grid>

                          <Grid container item spacing={1}>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Tasa Anual"
                                value={selectedCliente.tasa_anual + " %" || "-"}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Días de Financiamiento"
                                value={
                                  selectedCliente.dias_financiamiento || "-"
                                }
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Importe a Financiar"
                                value={
                                  FormatMoney(
                                    selectedCliente.importe_financiar,
                                    0
                                  ) || "-"
                                }
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Interés Pactado"
                                value={
                                  FormatMoney(
                                    selectedCliente.interes_pactado,
                                    0
                                  ) || "0"
                                }
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2.4}>
                              <TextField
                                label="Total a Pagar"
                                value={
                                  FormatMoney(selectedCliente.total_pagar, 0) ||
                                  "-"
                                }
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                    <div className="analisis-as-screen-footer">
                      {/* <div
                        className="analisis-as-screen-regresar"
                        onClick={handleCloseModal}
                      >
                        <ArrowBackIcon />
                        Regresar
                      </div> */}
                      <div
                        className="analisis-as-screen-x"
                        onClick={handleCloseModal}
                      >
                        X
                      </div>
                      <div className="button-container">
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ margin: "5px" }}
                          onClick={() => onImprimirPedido(1)}
                        >
                          <DownloadIcon /> Descargar el Pedido
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ margin: "5px" }}
                          onClick={() => onImprimirPedido(2)}
                        >
                          <DownloadIcon />
                          Descargar el Pagaré
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ margin: "5px" }}
                          onClick={() => onImprimirPedido(3)}
                        >
                          <DownloadIcon />
                          Descargar la Factura
                        </Button>
                      </div>
                    </div>
                  </PlantillaScreen>
                )}
              </div>
            </Modal>
          </div>
        )}
        {/* </> */}
        {/* ) : (
          <div></div>
        )} */}
      </div>
    </PlantillaScreen>
  );
};
